import { ExamInfo, QuestionInfo } from '@/store/modules/testprep/database'
import { $t } from '@/utils'

interface Config {
    timer: number
    mode: string
    images: any[]
}

export const formatSaveEQ = (examInfo: ExamInfo, testInfo: { exameId: string; questionList: QuestionInfo[] }, config: Config) => {
    return new Promise(async (resolve, reject) => {
        if (testInfo?.questionList?.length > 0) {
            examInfo.remoteId = testInfo.exameId
            examInfo.images = config.images
            examInfo.timer = config.timer
            examInfo.mode = config.mode
            examInfo.testList = testInfo.questionList.map((item: any) => {
                const answerList = item.answerList.map((oItem: any, oIndex: number) => {
                    return {
                        option: String.fromCharCode(65 + oIndex), //转化成A B C D……
                        text: oItem.answerText,
                        key: oIndex,
                        isRight: oItem.answerFlag
                    }
                })

                return {
                    type: item.questionType,
                    id: item.questionId,
                    tag: item.tagList,
                    title: item.questionText,
                    rightKey: answerList.filter((aItem: any) => aItem.isRight).map((item: any) => item.key),
                    list: answerList,
                    skill: item.explainText,
                    detail: ''
                }
            })

            resolve(examInfo)
        } else {
            reject()
        }
    })
}

export const getOptionClass = (exam?: ExamInfo | null, question?: QuestionInfo | null, key?: number) => {
    if (!exam || !question || key == undefined) {
        return ''
    }

    if (exam?.mode == 'mock') {
        if (question.answer == key) {
            return 'question-card-normal-option-selected'
        }
    } else {
        if (question.answer !== undefined && question.rightKey.includes(key)) {
            return 'question-card-normal-option-right'
        } else if (question.answer !== undefined && question.answer == key && !question.rightKey.includes(key)) {
            return 'question-card-normal-option-error'
        }
    }

    return ''
}

export const getOptionClassResult = (exam?: ExamInfo | null, question?: QuestionInfo | null, key?: number) => {
    if (!exam || !question || key == undefined) {
        return ''
    }

    if (question.answer !== undefined && question.rightKey.includes(key)) {
        return 'question-card-normal-option-right'
    } else if (question.answer !== undefined && question.answer == key && !question.rightKey.includes(key)) {
        return 'question-card-normal-option-error'
    }
}

export const formatSeconds = (seconds: number) => {
    var hours = Math.floor(seconds / 3600)
    var remainingSeconds = seconds % 3600
    var minutes = Math.ceil(remainingSeconds / 60)

    var res = []

    hours > 0 && res.push($t('testprep.timeSpentStr1').replace('=H=', hours.toString()))
    minutes >= 0 && res.push($t('testprep.timeSpentStr2').replace('=M=', minutes.toString()))

    return res.join(' ')
}

// 示例数据

// {
//     "subjectId": "10009",
//     "subject": "Calculus",
//     "exameMode": "Mock",
//     "questionType": "SINGLE",xxxxxxx
//     "questionCount": 10,
//     "taskList": [
//         "1933039629588418561"
//     ],
//     "questionCategory": "DailyQuiz"
// }

// {
//     "exameId": "1933039925727252481",
//     "questionList": []
// }

// {
//     "timer": 20,
//     "mode": "mock",
//     "images": [
//         {
//             "id": "1749707537612111554",
//             "taskId": "1933039629588418561",
//             "url": "https://solve_xai.198.daxue.cloud/api/blade-resource/oss/endpoint/get-static-file/1933039629538086914."
//         }
//     ]
// }
